import { useIsomorphicLayoutEffect } from '@/hooks/useIsomorphicLayoutEffect';
import { useAppearanceConfigModelStore } from '@/models/appearance-config/appearanceConfig';
import { useDocsDataModelStore } from '@/models/docs-data/docsData';
import { AppTheme } from '@/shared/constant/AppTheme';
import { LocalStorageKey } from '@/shared/constant/local-storage/LocalStorageKey';
import { usePersistFn } from 'ahooks';
import React from 'react';

export function useInitAndListenTheme() {
  const theme = useDocsDataModelStore((x) => x.docsBaseConfig.theme);
  const setAppTheme = useAppearanceConfigModelStore((x) => x.setAppTheme);
  const themePrimarySettings = useDocsDataModelStore((x) => x.docsBaseConfig.themePrimarySettings);
  const logoSettings = useDocsDataModelStore((x) => x.docsBaseConfig.logoSettings);
  const id = useDocsDataModelStore((x) => x.docsIdTypeData?.onlineId ?? 0);

  useIsomorphicLayoutEffect(() => {
    setAppTheme(window.__currentTheme);
  }, []);

  const switchThemeFn = usePersistFn((newAppTheme: AppTheme.Light | AppTheme.Dark) => {
    localStorage.removeItem(`${LocalStorageKey.UserTheme}.${id}`);
    window.__setDocsTheme(themePrimarySettings, logoSettings, newAppTheme);
    setAppTheme(newAppTheme);
  });

  React.useEffect(() => {
    if (theme !== AppTheme.System) {
      return () => {};
    }

    const media = window.matchMedia('(prefers-color-scheme: dark)');
    const handleChange = (e: MediaQueryListEvent) => {
      switchThemeFn(e.matches ? AppTheme.Dark : AppTheme.Light);
    };

    media.addEventListener('change', handleChange);
    return () => {
      media.removeEventListener('change', handleChange);
    };
  }, [switchThemeFn, theme]);
}
